var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachmentPrevious(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconAttachmentPrevious_svg__clip0_5652_7646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.477 17.167s-.111-.085-.15-.12C6.561 14.351.882 8.792.882 8.757c.075-.058 4.594-4.434 6.78-6.564L9.496.409c.575.574 1.137 1.144 1.7 1.714v.054c-.04.031-4.52 4.38-6.717 6.522-.036.035-.068.077-.103.12l.119.127c2.186 2.126 4.372 4.257 6.558 6.387.043.042.142.146.142.162l-1.718 1.672z",
    fill: "#879494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconAttachmentPrevious_svg__clip0_5652_7646"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 5.393 5.802)",
    d: "M0 0h16.758v10.312H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachmentPrevious);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconAttachmentPrevious.d99c043d.svg";
export { MemoForwardRef as ReactComponent };